import type { RoadmapBranchValue } from "@/infrastructure/supabase/database.types";

export const featureRoadmapVerdictsKeys = {
  all: ["feature-roadmap-verdicts"] as const,
  list: () => [...featureRoadmapVerdictsKeys.all, "list"] as const,
  byBranch: (branch: RoadmapBranchValue) =>
    [...featureRoadmapVerdictsKeys.all, "by-branch", branch] as const,
};
